import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetPointsListSystemClusterChartValuesResultType,
    GetPointsListSystemLineChartValuesResultType,
    GetPointsListSystemMetricsValuesResultType,
    GetPointsListSystemValuesResultType,
    PointListSystemsClient,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class PointListService extends CustomReportServiceBase<PointListSystemsClient, CustomReportServiceView> {
    constructor(protected override client: PointListSystemsClient) {
        super(client);
    }

    async getPointsListSystemValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetPointsListSystemValuesResultType[]> {
        return await lastValueFrom(this.client.pointListSystemsGetPointsListSystemValues(parameters));
    }

    async getPointsListSystemMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetPointsListSystemMetricsValuesResultType> {
        return await lastValueFrom(this.client.pointListSystemsGetPointsListSystemMetricsValues(parameters));
    }

    async getPointsListSystemLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetPointsListSystemLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.pointListSystemsGetPointsListSystemLineChartValues(parameters));
    }

    async getPointsListSystemColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetPointsListSystemClusterChartValuesResultType[]> {
        return await lastValueFrom(this.client.pointListSystemsGetPointsListSystemClusterChartValues(parameters));
    }

    async getPointsListSystemBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.pointListSystemsGetPointsListSystemBoxesValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.pointListSystemsSaveCatalogReport(body));
        else return await lastValueFrom(this.client.pointListSystemsSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.pointListSystemsGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.pointListSystemsCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.pointListSystemsGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.pointListSystemsResultAvailableColumns(organizationIds));
    }
}
